import { JustRightHeightModal } from 'components/styled/scoped';
import { message, ModalProps, Select } from 'antd';
import { useTranslate } from '@tolgee/react';
import { cx, css } from '@emotion/css';
import { useAssistants } from 'views/Conversation/Sider/ToDoBundle/useApi';
import { useState } from 'react';
import { useRequest } from 'ahooks';
import { batchTransferTodo } from '../service';

export interface BatchTransferProps extends ModalProps {
  records: Todo.Record[];
}

export const BatchTransferWithResult = (props: BatchTransferProps) => {
  const { t } = useTranslate();
  const { className, visible, records, onCancel, ...restProps } = props;
  const [assistantId, setAssistantId] = useState<string>('');
  const firstRecord = records[0];

  const { data: assistants } = useAssistants(firstRecord.storeId);

  const { runAsync, loading } = useRequest(
    () =>
      batchTransferTodo({
        ids: records.map((record) => record.id),
        operator: assistantId,
      }),
    {
      manual: true,
      onSuccess: () => {
        message.success(t('已转交'));
        onCancel?.({} as any);
      },
      onError: () => {
        message.error(t('转交失败，请稍后再试'));
      },
    },
  );

  return (
    <JustRightHeightModal
      title={t('批量转交')}
      width={420}
      visible={visible}
      onCancel={onCancel}
      okText={t('ViewDashboard.确认')}
      onOk={runAsync}
      okButtonProps={{
        loading,
        disabled: !assistantId,
      }}
      className={cx(
        css`
          .ant-modal-body {
            padding: 16px;
            margin: 0;
          }
        `,
        className,
      )}
      {...restProps}
    >
      <div className="mb-[16px]">{t('todo.受理客服')}</div>
      <Select
        showSearch
        className="w-full"
        options={assistants.map((assistant) => ({
          label: assistant.name,
          value: assistant.id,
        }))}
        placeholder={t('department.请选择x', { x: t('todo.受理客服').toLowerCase() })}
        filterOption={(input, option) =>
          (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
        }
        onChange={setAssistantId}
      />
    </JustRightHeightModal>
  );
};
